import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MASTER_MEALS_ONLY } from '../config/master-meals-only';
var MasterLockDirective = /** @class */ (function () {
    function MasterLockDirective(elementRef) {
        this.elementRef = elementRef;
        this.blockEvent = function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        };
    }
    Object.defineProperty(MasterLockDirective.prototype, "locked", {
        get: function () {
            return MASTER_MEALS_ONLY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MasterLockDirective.prototype, "ariaDisabled", {
        get: function () {
            return MASTER_MEALS_ONLY ? 'true' : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MasterLockDirective.prototype, "lockedTitle", {
        get: function () {
            return MASTER_MEALS_ONLY ? 'Временно недостъпно' : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MasterLockDirective.prototype, "disabled", {
        get: function () {
            if (!MASTER_MEALS_ONLY || this.elementRef.nativeElement.tagName !== 'BUTTON') {
                return null;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    MasterLockDirective.prototype.ngOnInit = function () {
        if (!MASTER_MEALS_ONLY) {
            return;
        }
        this.elementRef.nativeElement.addEventListener('click', this.blockEvent, true);
    };
    MasterLockDirective.prototype.ngOnDestroy = function () {
        this.elementRef.nativeElement.removeEventListener('click', this.blockEvent, true);
    };
    return MasterLockDirective;
}());
export { MasterLockDirective };
